import { Card, CardBody, CardHeader, Heading } from "@chakra-ui/react";
import React from "react";

const CountCard = ({ label, value }) => {
  return (
    <Card cursor={"pointer"} height="150px" overflow="hidden">
      <CardBody>
        <Heading size="md" noOfLines={2} fontSize={{ base: "md", md: "lg" }}>
          {label}
        </Heading>
      </CardBody>
      <CardHeader>
        <Heading fontSize={{ base: "2xl", md: "3xl" }} isTruncated>
          {value}
        </Heading>
      </CardHeader>
    </Card>
  );
};

export default CountCard;
